import React from 'react';
import { Holygrail } from '../all-files/components';
import {
  CpSavedViewsInProjectList,
  CpSavedViewsInProjectListProps,
} from './cp-saved-views-in-project-list';
import {
  CpListInTheProjectTasksListWidget,
  CpListInTheProjectTasksListWidgetProps,
} from './list';
import { isEmptyTaskSidePane } from './utils';

export const CpProjectTasksListMobile: React.FC<
  CpSavedViewsInProjectListProps & CpListInTheProjectTasksListWidgetProps
> = ({
  gridApi,
  onGridReady,
  onViewClick,
  rows,
  sharedViews,
  spotlitViews,
  tasksToBeShown,
  selectedViewId,
  viewName,
  isLoading,
}) => {
  const isSidepaneEmpty = isEmptyTaskSidePane({
    tasksToBeShown,
    sharedViews,
    spotlitViews,
  });

  if (isSidepaneEmpty) {
    return (
      <Holygrail>
        <CpListInTheProjectTasksListWidget
          viewName={viewName}
          rows={rows}
          gridApi={gridApi}
          onGridReady={onGridReady}
          tasksToBeShown={tasksToBeShown}
          isLoading={isLoading}
        />
      </Holygrail>
    );
  }

  return (
    <Holygrail>
      {selectedViewId ? (
        <CpListInTheProjectTasksListWidget
          viewName={viewName}
          rows={rows}
          gridApi={gridApi}
          onGridReady={onGridReady}
          tasksToBeShown={tasksToBeShown}
          isLoading={isLoading}
        />
      ) : (
        <CpSavedViewsInProjectList
          selectedViewId={selectedViewId}
          onViewClick={onViewClick}
          sharedViews={sharedViews}
          spotlitViews={spotlitViews}
          tasksToBeShown={tasksToBeShown}
        />
      )}
    </Holygrail>
  );
};
